'use client'

import { useEffect } from 'react'

import { isGuestTappedOn, setGuestTappedOn } from '@/app/_utils/sessionUtils'
import { logAmplitude, setAmplitudeUserProperties } from '@/hooks/useAmplitude'

interface Props {
  venueSlug: string
  menuStatus: string
}

export function GuestTapOnTracker({ venueSlug, menuStatus }: Props) {
  useEffect(() => {
    setAmplitudeUserProperties({ 'menu.status': menuStatus })
    if (!isGuestTappedOn(venueSlug)) {
      logAmplitude(`Guest tapped on`, { 'page.referrer': document.referrer })
      setGuestTappedOn(venueSlug)
    }
  }, [])

  return null // This component just tracks, doesn't render anything
}
